const transactionTypes = {
  SEND: `MsgSend`,
  DELEGATE: `MsgDelegate`,
  MULTIDELEGATE: `MsgMultiDelegate`,
  UNDELEGATE: `MsgUndelegate`,
  REDELEGATE: `MsgRedelegate`,
  SUBMIT_PROPOSAL: `MsgSubmitProposal`,
  VOTE: `MsgVote`,
  DEPOSIT: `MsgDeposit`,
  WITHDRAW: `MsgWithdrawDelegationReward`
}

export default transactionTypes
